import { render, staticRenderFns } from "./VeBorderSettings.vue?vue&type=template&id=45608366&scoped=true"
import script from "./VeBorderSettings.vue?vue&type=script&lang=js"
export * from "./VeBorderSettings.vue?vue&type=script&lang=js"
import style0 from "./VeBorderSettings.vue?vue&type=style&index=0&id=45608366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45608366",
  null
  
)

export default component.exports